import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../api/axiosInstance";
import { requestNotificationPermission } from "../firebase";

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ phone, password }, { rejectWithValue }) => {
    try {
      const fcmToken = await requestNotificationPermission();

      const payload = { phone, password };
      if (fcmToken) {
        payload.fcm_dispatcher_token = fcmToken;
      } else {
        payload.fcm_dispatcher_token = "";
      }

      const response = await axiosInstance.post(
        "users/dispatcher/login/",
        payload
      );

      localStorage.setItem("user", JSON.stringify(response.data.user));

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Server error");
    }
  }
);

// export const loginUser = createAsyncThunk(
//   "auth/loginUser",
//   async ({ phone, password }, thunkAPI) => {
//     try {
//       const response = await axiosInstance.post("users/dispatcher/login/", {
//         phone,
//         password,
//       });

//       localStorage.setItem("user", JSON.stringify(response.data.user));

//       thunkAPI.dispatch(fetchNotifications());

//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response?.data || "Server error");
//     }
//   }
// );

export const fetchNotifications = createAsyncThunk(
  "auth/fetchNotifications",
  async (url, { rejectWithValue }) => {
    try {
      let finalUrl;

      if (!url) {
        finalUrl = "users/notifications/";
      } else if (url.startsWith("http")) {
        finalUrl = url;
      } else {
        finalUrl = url;
      }

      const res = await axiosInstance.get(finalUrl);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Error fetching notifications"
      );
    }
  }
);

export const logoutUser = createAsyncThunk("auth/logoutUser", async () => {
  try {
    await axiosInstance.post(
      "dispatcher/logout/",
      {},
      { _isLogoutRequest: true } // avoid interceptor loop
    );
  } catch (err) {}
  localStorage.clear();
});

function safeJsonParse(key) {
  const item = localStorage.getItem(key);
  if (!item) return null;
  try {
    return JSON.parse(item);
  } catch (e) {
    localStorage.removeItem(key);
    return null;
  }
}

const authSlice = createSlice({
  name: "auth",
  initialState: {
    // user: JSON.parse(localStorage.getItem("user")) || null,
    user: safeJsonParse("user"),
    loading: false,
    error: null,
    notifications: [],
    nextPage: null,
    previousPage: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.detail || "Login failed";
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.user = null;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.notifications = action.payload.results;
        state.nextPage = action.payload.next;
        state.previousPage = action.payload.previous;
      });
  },
});

// export const { logout } = authSlice.actions;
export default authSlice.reducer;
